import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated);
  console.log(isAuthenticated)
  return isAuthenticated ? <>{children}</> : <Navigate to="/sign-in" />;
};

export default PrivateRoute;
